module.exports = __webpack_public_path__ + "static/10-IMG-1680-6eff9852679cffd683d507fd3418e0e2.jpg";